import { useTranslation } from 'react-i18next'
import { Button } from '../ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog'
import { UNBLOCK_KEY, detectUnblockBrowser } from '../../utils/unblock-browser'

// Three steps to the switch on every browser, then "reload".
const STEP_COUNT = 3

interface PushUnblockStepsProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function PushUnblockSteps({ open, onOpenChange }: PushUnblockStepsProps) {
  const { t } = useTranslation()
  const browser = detectUnblockBrowser()
  const steps = Array.from({ length: STEP_COUNT }, (_, index) =>
    t(`pushNudge.unblock.${UNBLOCK_KEY[browser]}.step${index + 1}`),
  )

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>{t('pushNudge.unblock.title')}</DialogTitle>
          <DialogDescription>{t('pushNudge.unblock.description')}</DialogDescription>
        </DialogHeader>
        <ol className="flex flex-col gap-3">
          {[...steps, t('pushNudge.unblock.reload')].map((step, index) => (
            <li key={step} className="flex items-start gap-3 text-sm">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-muted text-xs font-semibold">
                {index + 1}
              </span>
              <span className="flex-1 pt-1">{step}</span>
            </li>
          ))}
        </ol>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t('common.close', { defaultValue: 'Close' })}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
